import React, { useContext } from 'react';
import { graphql } from 'gatsby';
import { KontentStringValue } from '../../../types/KontentProps';
import PageRelevancyTags from './PageRelevancyTags';
import { useIcons } from '../Global/DataUtils/iconQueries';
import { TaxonomyContext } from '../../templates/TaxonomyContext';

export interface PageRelevancyTagsProps {
    statement: KontentStringValue;
    color: {
        value: {
            codename: string;
        };
    };
    kontentItemId?: string;
}

const PageRelevancyTagsContainer: React.FC<any> = (props) => {
    let icons = useIcons();
    let taxonomies = useContext(TaxonomyContext);

    return (
        <PageRelevancyTags icons={icons} taxonomies={taxonomies} {...props} />
    );
};

export default PageRelevancyTagsContainer;

export const fragmentPageRelevancyTags = graphql`
    fragment PageRelevancyTags on kontent_item_component___page_relevancy_tags {
        id
        elements {
            statement {
                value
            }
            color {
                value {
                    codename
                }
            }
        }
        parent {
            id
        }
    }
`;
